"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castello-molina-di-fiemme": {
    "a5fe05a3": [{
      "hkey": "65e3b390",
      "slug": "castello-di-fiemme",
      "name": "Castello di Fiemme",
      "primary": true,
      "skipSearch": false
    }],
    "castello": [{
      "hkey": "65e3b390",
      "slug": "castello-di-fiemme",
      "name": "Castello di Fiemme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "da57e0cc": [{
      "hkey": "153dfbcd",
      "slug": "molina-di-fiemme",
      "name": "Molina di Fiemme",
      "primary": true,
      "skipSearch": false
    }],
    "molina": [{
      "hkey": "153dfbcd",
      "slug": "molina-di-fiemme",
      "name": "Molina di Fiemme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "162ba161": [{
      "hkey": "5b7dc422",
      "slug": "castello-molina-di-fiemme",
      "name": "Castello-Molina di Fiemme",
      "primary": true,
      "skipSearch": false
    }],
    "predaia": [{
      "hkey": "5b7dc422",
      "slug": "castello-molina-di-fiemme",
      "name": "Castello-Molina di Fiemme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;